import React, { Dispatch, SetStateAction, useContext } from 'react'
import {
  BI_MONTHLY_FACIAL_BANNER_TEXT,
  MONTHLY_FACIAL_BANNER_TEXT,
  SUMMER_PROMO_DESCRIPTION,
} from 'utils/constants/Messages'
import { isEnableSummerPromo } from 'utils/helper-functions'
import useNavigate from 'utils/navigation/useCustomNavigate'
import useMembership from 'views/hooks/useMembership'
import { AppContext } from '../../../providers/context/App'
import AppointmentSubtotal from './appointment-subtotal'
import './appointment.scss'

type Props = {
  setTotal: Dispatch<SetStateAction<number>>
}

const AppointmentPrice = ({ setTotal }: Props) => {
  const { appMasterData } = useContext(AppContext)
  const isLaserFacial = appMasterData.isLaserFacial
  const { isInfluencerFlow } = useNavigate()
  const { isMember, isBiMonthlyMember } = useMembership()

  const marketingObj = appMasterData.location.confirmationScreenPromo ?? {}

  return (
    <div className="price-section">
      <AppointmentSubtotal setTotal={setTotal} />

      {isMember &&
        !isLaserFacial &&
        !isInfluencerFlow &&
        !appMasterData.isMicroNeedling && (
          <div className="member-text">
            <span className="body-2">
              {isBiMonthlyMember
                ? BI_MONTHLY_FACIAL_BANNER_TEXT
                : MONTHLY_FACIAL_BANNER_TEXT}
            </span>
          </div>
        )}

      {!isMember &&
        !isLaserFacial &&
        !isInfluencerFlow &&
        !appMasterData.isMicroNeedling && (
          <>
            {appMasterData.location.enableNewClientPromo &&
              (!!marketingObj.name || !!marketingObj.subheading) &&
              !appMasterData.isLoggedIn && (
                <div className="offer-wrapper">
                  <div className="offer-banner">
                    <div className="offer-head">{marketingObj.name}</div>
                    <div className="offer-subhead">
                      {marketingObj.subheading}
                    </div>
                  </div>
                </div>
              )}
          </>
        )}
      {/* Summer Glow Promo Banner */}
      {!isLaserFacial &&
        isEnableSummerPromo(
          appMasterData.selectedDate,
          appMasterData.location.name
        ) && (
          <div className="summer-promo-banner">
            <div className="headline">
              One free {isMember ? '$80' : '$50'} value enhancement
            </div>
            <div className="description">
              {SUMMER_PROMO_DESCRIPTION(isMember)}
            </div>
          </div>
        )}
    </div>
  )
}

export default React.memo(AppointmentPrice)
